import { gsap, ScrollTrigger } from './gsap.js';
import Lenis from 'lenis';

// Mobile browsers fire a resize every time the address bar hides, and a refresh
// on that is never worth the jump it causes.

ScrollTrigger.config({ ignoreMobileResize: true });

/**
 * Opening DevTools or dragging the window edge resets the page to the top:
 * while the viewport is changing, Lenis remeasures and clamps its position,
 * emitting a scroll of 0 before the new layout exists.
 *
 * The position the reader actually scrolled to is tracked continuously and
 * handed back once the resizing stops. The listener is registered before Lenis
 * is constructed on purpose — listeners run in registration order, so the flag
 * is already up when Lenis emits its clamped values, and they never overwrite
 * the stored position.
 */

const settleDelay = 180;

let lastScroll = window.scrollY;
let isSettling = false;
let settleTimer = 0;

function onViewportResize() {
  isSettling = true;
  clearTimeout(settleTimer);

  settleTimer = setTimeout(restoreScroll, settleDelay);
}

window.addEventListener('resize', onViewportResize, { passive: true });
window.visualViewport?.addEventListener('resize', onViewportResize, { passive: true });

const lenis = new Lenis();

lenis.on('scroll', ScrollTrigger.update);

lenis.on('scroll', ({ scroll }) => {
  if (!isSettling) {
    lastScroll = scroll;
  }
});

gsap.ticker.add((time) => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);

function restoreScroll() {
  lenis.resize();

  if (Math.abs(lenis.scroll - lastScroll) > 1) {
    lenis.scrollTo(lastScroll, { immediate: true, force: true, lock: true });
  }

  requestAnimationFrame(() => {
    isSettling = false;
  });
}

ScrollTrigger.addEventListener('refresh', () => {
  if (!isSettling) {
    restoreScroll();
  }
});

export default lenis;
